import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "columns" }
const _hoisted_2 = {
  class: "account-box is-navigation p-0 mt-0",
  style: {"border":"none !important"}
}
const _hoisted_3 = { class: "account-menu me-5" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", {
  "aria-hidden": "true",
  class: "lnil lnil-user-alt"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "end" }, [
  /*#__PURE__*/_createElementVNode("i", {
    "aria-hidden": "true",
    class: "fas fa-arrow-right"
  })
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", {
  "aria-hidden": "true",
  class: "lnil lnil-quill"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-compact-left fs-3 align-middle me-3" }),
  /*#__PURE__*/_createTextVNode("Volver")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "end" }, [
  /*#__PURE__*/_createElementVNode("i", {
    "aria-hidden": "true",
    class: "fas fa-arrow-right"
  })
], -1)
const _hoisted_10 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_clientDash = _resolveComponent("clientDash")!
  const _component_clientApps = _resolveComponent("clientApps")!
  const _component_clientPlans = _resolveComponent("clientPlans")!
  const _component_clientDocuments = _resolveComponent("clientDocuments")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(!_ctx.layout.loading ? 'account-wrapper text-left' : 'w-100')
  }, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.isMobile && _ctx.layout.client)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["column is-4 ms-3", _ctx.isMobile ? '' : 'mt-5'])
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layout.sections, (section, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: _normalizeClass(["account-menu-item cursor-pointer", _ctx.layout.section == section.name ? 'router-link-active router-link-exact-active' : '']),
                    onClick: ($event: any) => (_ctx.$router.push({ path: '/client/' + _ctx.layout.client.id, query: { section:  section.name } }))
                  }, [
                    _hoisted_5,
                    _createElementVNode("span", null, [
                      _createElementVNode("i", {
                        class: _normalizeClass(section.icon + ' fs-3 align-middle me-3')
                      }, null, 2),
                      _createTextVNode(_toDisplayString(section.title), 1)
                    ]),
                    _hoisted_6
                  ], 10, _hoisted_4))
                }), 128)),
                _createElementVNode("div", {
                  class: "account-menu-item mt-2 cursor-pointer",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/clients/')))
                }, _hoisted_10)
              ])
            ])
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["column ps-0", _ctx.isMobile ? '' : 'mt-5'])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["form-body p-0 m-0 friBackWhite", _ctx.isMobile ? 'pt-0' : 'p-0'])
        }, [
          (_ctx.layout.section == 'dashboard')
            ? (_openBlock(), _createBlock(_component_clientDash, {
                key: 0,
                clientId: _ctx.layout.client.id,
                isMobile: _ctx.isMobile
              }, null, 8, ["clientId", "isMobile"]))
            : (_ctx.layout.section == 'apps')
              ? (_openBlock(), _createBlock(_component_clientApps, {
                  key: 1,
                  clientId: _ctx.layout.client.id,
                  isMobile: _ctx.isMobile
                }, null, 8, ["clientId", "isMobile"]))
              : (_ctx.layout.section == 'plans')
                ? (_openBlock(), _createBlock(_component_clientPlans, {
                    key: 2,
                    clientId: _ctx.layout.client.id,
                    isMobile: _ctx.isMobile
                  }, null, 8, ["clientId", "isMobile"]))
                : (_ctx.layout.section == 'documents')
                  ? (_openBlock(), _createBlock(_component_clientDocuments, {
                      key: 3,
                      clientId: _ctx.layout.client.id,
                      isMobile: _ctx.isMobile
                    }, null, 8, ["clientId", "isMobile"]))
                  : _createCommentVNode("", true)
        ], 2)
      ], 2)
    ])
  ], 2))
}